/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'
import "./ContactPage.css"
import Form from "../../Components/Form/Form"
import { useTranslation } from 'react-i18next';

function ContactPage() {
   /*  console.log(document.location.pathname); */
   const { t } = useTranslation();
    return (
        <div className='contact-container'>

            <div className="contact-content">

                <div className="contact-header">
                    <h3>{t('nav-contact')}</h3>
                </div>

                

                <div className='contact-maps'>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1524.3827398894161!2d28.770001210065665!3d40.16977499148234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ca114e38c4006f%3A0xd7fb7b8b65f7c6d!2sHigh%20Performance%20Compounds%20Kau%C3%A7uk%20A.%C5%9E.!5e0!3m2!1str!2str!4v1669196746028!5m2!1str!2str" loading="lazy" ></iframe>
                </div>

                <div className="brand-contact-info">
                    <h4>{t('contact-header-text')}</h4>
                    <p>{t('contact-p-one')}</p>
                    <p>{t('contact-p-two')}</p>
                    <p>{t('contact-p-three')}</p>
                </div>

                <div className='contact-form-container'>
                    <h3>{t('contact-form-header')}</h3>
                    <Form />
                </div>
                
            </div>
        </div>
    )
}

export default ContactPage